import React from 'react'
import { SchemeMaster } from '../../../schemes/models/scheme_master';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import StepFormActions from '../create_user_shared/step_form_actions';
import { black, greyEnabled, purple, purpleLight } from '../../../../theme/colors';

interface props {
    onSubmit: () => void;
    stepperCount: number;
    setStepperCount: (val: number) => void;
    masterDataList: SchemeMaster;
    masterDataLoading?: boolean;
    areaOfInterest: number[] | null;
    setAreaOfInterest: (val: number[] | ((prev: number[] | null) => number[])) => void;
    modifyUser?: boolean | undefined;
    disableSaveBtn?: boolean;
    setDisableSaveBtn?: (val: boolean) => void;
    submitting?: boolean;
}


export default function AreaOfInterest({
    stepperCount,
    onSubmit,
    setStepperCount,
    masterDataList,
    masterDataLoading = false,
    areaOfInterest,
    setAreaOfInterest,
    modifyUser,
    disableSaveBtn = false,
    setDisableSaveBtn,
    submitting = false,
}
    : props) {
    return (
        <Box mt={1}>
            <Typography variant="subtitle1" fontWeight={700} color={black}>
                Areas of Interest
            </Typography>
            <Typography variant="body2" color={greyEnabled} mb={2}>
                Select all the topics this user would like to receive updates about.
            </Typography>
            {masterDataLoading ? (
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress size={28} sx={{ color: purple }} />
                </Box>
            ) : (
            <Grid container spacing={1}>
                {masterDataList?.areasOfInterest?.map((item) => {
                    if (item?.value === 'All') return null;
                    const selected = !!areaOfInterest?.includes(item?.id);
                    return (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={item.id}>
                            <Box
                                onClick={() => {
                                    // Functional update — selecting multiple chips in quick
                                    // succession could otherwise race: each click's handler
                                    // captured the `areaOfInterest` prop value from its own
                                    // render, so a fast second click could compute its next
                                    // array from data that didn't yet include the first
                                    // click's change, silently dropping it.
                                    setAreaOfInterest((prev: number[] | null) => {
                                        const list = prev || [];
                                        return list.includes(item?.id)
                                            ? list.filter((i) => i !== item?.id)
                                            : [...list, item?.id];
                                    })
                                    setDisableSaveBtn?.(false)
                                }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    border: `1px solid ${selected ? purple : '#D6D6D6'}`,
                                    bgcolor: selected ? purpleLight : 'transparent',
                                    borderRadius: 2,
                                    px: 1.5,
                                    py: 0.75,
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    transition: 'border-color 0.15s ease, background-color 0.15s ease',
                                    "&:hover": {
                                        borderColor: purple,
                                    },
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    fontWeight={selected ? 600 : 400}
                                    color={selected ? purple : black}
                                >
                                    {item?.value}
                                </Typography>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
            )}
            <StepFormActions
                showBack={!modifyUser}
                onBack={() => setStepperCount(stepperCount - 1)}
                disabled={disableSaveBtn || masterDataLoading}
                loading={submitting}
                loadingLabel="Creating User..."
                onSubmitClick={onSubmit}
                type="button"
                submitLabel={!modifyUser ? "Proceed and Create User" : "Save Changes"}
            />
        </Box>
    )
}
